<template>
    <div>
        <div class="fade-background"></div>
        <div class="fp_container">
            <div class="vcore_row">
                <div class="vcore_col--md--12">
                    <div class="title">Prototype Manager</div>
                </div>
            </div>
            <div class="vcore_row">
                <div class="vcore_col--md--12">
                    <div class="subtitle">User Sign In</div>
                </div>
            </div>
            <div class="vcore_row">
                <div class="vcore_col--md--12">
                    <div class="vcore_input-group">
                        <label class="vcore_input-label">Username</label>
                        <input
                                type="text"
                                class="vcore_input"
                                :value="loginUsername"
                                @input="loginUsernameUpdate"
                        />
                    </div>
                </div>
            </div>
            <div class="vcore_row">
                <div class="vcore_col--md--12">
                    <div class="vcore_input-group">
                        <label class="vcore_input-label">Password</label>
                        <input
                                type="password"
                                class="vcore_input"
                                :value="loginPw"
                                @input="loginPwUpdate"
                        />
                    </div>
                </div>
            </div>
            <div class="vcore_row">
                <div class="vcore_col--md--9"></div>
                <div class="vcore_col--md--3">
                    <button class="vcore_btn vcore_btn--primary vcore_btn--md vcore_btn--blue vcore_btn--block" type="button" @click="login">
                        Sign In
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "Login",
        methods: {
            loginUsernameUpdate(e){
                this.$store.commit("loginUsernameUpdate", e.target.value);
            },
            loginPwUpdate(e){
                this.$store.commit("loginPwUpdate", e.target.value);
            },
            login(){
                let userInfo = {
                    loginUsername: this.loginUsername,
                    loginPw: this.loginPw
                };
                this.$store.dispatch("login", userInfo);
            }
        },
        computed: {
            ...mapGetters([
                "loginPw",
                "loginUsername",
                "authToken"
               ])
        }
    }
</script>

<style lang="scss" scoped>
    .vcore_row {
        margin: 10px 0;
    }

    .fade-background{
        background-color: #f7f9fa;
        position: fixed;
        top:0;
        left:0;
        width: 100%;
        height: 100%;
    }

    .fp_container {
        background-color: rgba(255, 255, 255, .9);
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border-top: 12px #2b78e4 solid;
        position: absolute;
        top: 45%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: 25px;
        margin-bottom: 110px;
        width: 570px;
    }

    .title {
        font-family: "Open Sans", sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 32px;
        text-align: left;
        color: #2b78e4;
    }

    .subtitle {
        font-family: "Open Sans", sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 24px;
        margin-top: 20px;
        margin-bottom: 5px;
        text-align: left;
        color: #666666;
    }

    .vcore_input-label {
        font-family: "Open Sans", sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 24px;
        line-height: 33px;
        float: left;
        color: #666666;
    }

    .vcore_btn--blue {
        float: right;
        margin-top: 15px;
    }

</style>
